module.exports = __webpack_public_path__ + "img/64 (1).a6a1d618.png";